import type {
  ConversationListResultDTO,
  ConversationResultDTO,
  UserResultDTO,
} from '@nora-monorepo/nora-api-client';

import { getInitials } from '#ui-shared/utils/get-initials';

export function getIconOrIntitials(
  conversation: ConversationListResultDTO,
  user?: UserResultDTO,
): { icon?: string; initials?: string } {
  let icon, initials;

  if (conversation.operationId) {
    icon = '';
  }
  else if (conversation.userCount > 2 || conversation.groupCount >= 1) {
    icon = 'groups';
  }
  else {
    initials = getInitialsFromConversationOrUser(conversation, user);
  }

  return { icon, initials };
}

export function getIcon(
  conversation: ConversationResultDTO,
): string | undefined {
  const icon
    = conversation.users?.length > 2 || conversation.groups?.length >= 1
      ? 'groups'
      : 'person';

  return icon;
}

export function getInitialsFromConversationOrUser(
  conversation: ConversationListResultDTO,
  user?: UserResultDTO,
): string {
  if (!user) {
    return '';
  }

  if (conversation.userCount === 1) {
    return getInitials(conversation.fallbackTitle);
  }

  return getInitials(user);
}
